// Risk Halt API — 화면 14.
// 권위: ARCH_DASHBOARD.md v1.8 §4.14 + §6.2 (REST 계약).
// Loss 원천 값은 반환하지 않는다 (ARCH_RISK_ORCHESTRATION §3 Non-Goals).
// ADR-RISK-07 — 변동성 지수 트리거 폐기. 관련 필드/이벤트 제거.

import { apiGet, apiPost } from './client';

export type HaltAction = 'none' | 'halt_new_orders' | 'reduce_all_50pct' | 'halt_all';
export const ALL_HALT_ACTIONS: HaltAction[] = [
  'none',
  'halt_new_orders',
  'reduce_all_50pct',
  'halt_all',
];

export interface HaltStatus {
  halted: boolean;
  action: HaltAction;
  reason_code: string | null;
  reason_detail: string | null;
  since: string | null;
  until: string | null;
  trigger_event_id: string | null;
  requires_operator_resume: boolean;
  additional_triggers: string[];
  last_resume_ready_at: string | null;
}

export async function getHaltStatus(): Promise<HaltStatus> {
  return apiGet<HaltStatus>('/api/v1/risk/halt-status');
}

export interface HaltHistoryItem {
  triggered_at: string;
  action: HaltAction;
  trigger_event_code: string;
  trigger_event_id: string;
  recovered_at: string | null;
  duration_seconds: number | null;
  requires_operator_resume: boolean;
  resumed_by: string | null;
  reason_detail: string | null;
}

export interface HaltHistoryListResponse {
  items: HaltHistoryItem[];
  total: number;
  page: number;
  size: number;
}

export interface HaltHistoryQuery {
  from?: string;
  to?: string;
  action?: HaltAction[];
  reason_code?: string[];
  page?: number;
  size?: number;
}

export async function listHaltHistory(q: HaltHistoryQuery = {}): Promise<HaltHistoryListResponse> {
  const p = new URLSearchParams();
  if (q.from) p.set('from', q.from);
  if (q.to) p.set('to', q.to);
  if (q.action && q.action.length > 0) p.set('action', q.action.join(','));
  if (q.reason_code && q.reason_code.length > 0)
    p.set('reason_code', q.reason_code.join(','));
  p.set('page', String(Math.max(0, q.page ?? 0)));
  p.set('size', String(Math.max(1, Math.min(200, q.size ?? 50))));
  return apiGet<HaltHistoryListResponse>(`/api/v1/risk/halt-history?${p.toString()}`);
}

export interface HaltHistorySummary {
  loss_threshold_breached_7d: number;
  agent_down_7d: number;
  broker_api_7d: number;
  data_feed_stale_7d: number;
  market_circuit_breaker_7d: number;
}

export async function getHaltHistorySummary(windowDays = 7): Promise<HaltHistorySummary> {
  return apiGet<HaltHistorySummary>(
    `/api/v1/risk/halt-history/summary?window_days=${windowDays}`,
  );
}

export interface HaltResumeRequest {
  approver: string;
  reason: string;
  password: string;
}

export interface HaltResumeResponse {
  request_id: string;
  status: 'queued' | 'accepted';
}

export async function resumeHalt(body: HaltResumeRequest): Promise<HaltResumeResponse> {
  return apiPost<HaltResumeResponse>('/api/v1/risk/halt/resume', body);
}
